// @flow
import Cookies from "js-cookie";

export const getSessionId = () => Cookies.get("session");

export default getSessionId;